import { render, staticRenderFns } from "./after_sales.vue?vue&type=template&id=184c8db6&"
import script from "./after_sales.vue?vue&type=script&lang=js&"
export * from "./after_sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports